// extracted by mini-css-extract-plugin
module.exports = {"loadingSpinner":"MenuList_loadingSpinner__7K590","menuItem":"MenuList_menuItem__AoPNB","link":"MenuList_link__hcaJu"};